import { Component } from "react";
import { Container, ListGroup, ListGroupItem } from "react-bootstrap";


export class ResponseList extends Component {
    constructor(props) {
        super(props)
    }

    render() {
        return (
            <Container style={{maxHeight: "400px", overflowY: 'scroll'}}>
                <ListGroup>
                    {this.props.responses.map((resp, idx) => 
                        <ListGroupItem key={idx}>{resp}</ListGroupItem>
                    )}
                </ListGroup>
            </Container>
        )
    }
}